import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AddMemberToOrder from '@components/assign-team-member/AddMemberToOrder';
import LoaderComponent from '@components/LoaderComponent';
import CommonImage from '@components/CommonImage';
import ModalContainer from '@components/modals/ModalContainer';

import ReportOption from '@features/order/ReportOption';
import AllStyles from '@features/order/components/AllStyles';
import DesignOrderModal from '@features/order/components/orderInfo/DesignOrderModal';

import { fetchAllUsersByTypes } from '@store/orders/actions';

import { capitalizeFirstLetter, changeDateFormat, dateOrder, getShortName, repeatTag } from '@utils/Util';

const BACK_ICON = process.env.PUBLIC_URL + '/icons/Left-arrow.svg';
const DELIVERY_ICON = `${process.env.PUBLIC_URL}/images/icons/info_icon.svg`;

const TopBar = ({
	details,
	orderId,
	onProjectDetailsCallBack,
	projectStatus,
	isDrafted = false,
	setProductRefNumber
}) => {
	const [loading] = useState(false);
	const [showAllStyles, setShowAllStyles] = useState(false);
	const [openOrderDesignModal, setOpenOrderDesignModal] = useState(false);

	const dispatch = useDispatch();
	const AllStylesModal = useRef(null);
	const navigate = useNavigate();

	const onClose = () => {
		setOpenOrderDesignModal(false);
	};

	const handleClickOutside = (event) => {
		if (AllStylesModal.current && !AllStylesModal.current.contains(event.target)) {
			setShowAllStyles(false);
		}
	};

	useEffect(() => {
		dispatch(fetchAllUsersByTypes());
	}, []);

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, { capture: true });
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [details.orderMemberResponseList]);

	const onStyleClose = () => {
		setShowAllStyles(false);
	};

	const renderStatus = (status) => {
		switch (capitalizeFirstLetter(status)) {
			case 'Running':
				return 'Production';
			case 'On_shipment':
				return 'On Shipment';
			default:
				return capitalizeFirstLetter(status);
		}
	};

	return (
		<LoaderComponent loading={loading}>
			{isDrafted && (
				<div className="top-header bg-white">
					<div className="page-title-area pb-3 d-flex justify-content-between align-items-center">
						<div className="d-flex align-items-center">
							<button className="button text size32 p-0">
								<img
									className="cursor-pointer"
									src={BACK_ICON}
									alt="Back"
									onClick={() => navigate(-1)}
								/>
							</button>
							<h1 className="semibold-16">CREATE ORDER</h1>
							<p className="gray_dark_02 regular-14 ml-1">({details.name})</p>
							<div className="ml-2">{details.isRepeatOrder && repeatTag()}</div>
						</div>
						<button
							onClick={() => setOpenOrderDesignModal(true)}
							className="button outline size32"
						>
							{details?.totalStyles} Designs
						</button>
					</div>
				</div>
			)}
			{openOrderDesignModal && (
				<ModalContainer onCloseModal={onClose} className="upload-style-modal">
					<DesignOrderModal
						orderId={orderId}
						onCloseModal={onClose}
						setProductRefNumber={setProductRefNumber}
					/>
				</ModalContainer>
			)}
			{!isDrafted && (
				<section className="order-details-section bg-white" style={{ position: 'relative' }}>
					<div className="container-fluid">
						<div className="row align-items-center order-details-top">
							<div className="col-md-8 col-sm-12 pl-0">
								<div className="d-flex justify-content-between align-items-center">
									<div className="order-title d-flex align-items-center">
										<img
											className="cursor-pointer"
											src={BACK_ICON}
											alt="Back"
											onClick={() => navigate(-1)}
										/>
										<Tooltip title={details.name || ''} placement="top" arrow>
											<h3>{getShortName(details.name, 35)}</h3>
										</Tooltip>{' '}
										{details.orderRefNumber && (
											<span className="order-number">({details.orderRefNumber})</span>
										)}
										{details.brandResponse?.name && (
											<span className="brand-common-design mr-2">
												{details.brandResponse?.name}
											</span>
										)}
										{details.status && (
											<span className={`order-status ${details.status.toLowerCase()}`}>
												{renderStatus(details.status)}
											</span>
										)}
										<span>
											<ReportOption
												orderStatus={details.status}
												projectStatus={projectStatus}
											/>
										</span>
									</div>
									<div className="mr-5">{details.isRepeatOrder && repeatTag()}</div>
								</div>
							</div>
							<div className="col-md-4 col-sm-12 text-right pr-0">
								<div className="d-flex justify-content-end align-items-center">
									<span className="topbar-teammember">
										<div>
											<AddMemberToOrder orderId={orderId} />
										</div>
									</span>
									<div className="delivery-status ml-2">
										{projectStatus !== 'ON_SHIPMENT' && projectStatus !== 'COMPLETED' && (
											<button>
												<span className="gray_dark_03">ETD: </span>
												<span>
													{details.timeLeft} days
													<CommonImage src={DELIVERY_ICON} />
												</span>
											</button>
										)}
										{(projectStatus === 'ON_SHIPMENT' ||
											projectStatus === 'COMPLETED') && (
											<button>
												<span className="gray_dark_03">DELIVERED: </span>
												<span>
													{details.actualDeliveryDate
														? changeDateFormat(
																details.actualDeliveryDate,
																'YYYY-MM-DD',
																'DD-MMM'
															)
														: '--'}
												</span>
											</button>
										)}
										<div className="date-details delivery-date-details text-left">
											{details?.deliveryDateList?.map((item, idx) => (
												<ul className="start" key={idx}>
													<li>
														{idx + 1}
														{dateOrder(idx + 1)} ETD:
													</li>
													<li>
														{changeDateFormat(item, 'YYYY-MM-DD', 'DD MMM, YYYY')}
													</li>
												</ul>
											))}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			)}

			{showAllStyles && (
				<div className="all-style-absolute-section" ref={AllStylesModal}>
					<AllStyles onClose={onStyleClose} onProjectDetailsCallBack={onProjectDetailsCallBack} />
				</div>
			)}
		</LoaderComponent>
	);
};

export default TopBar;
